import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Select, Typography } from "antd";
import { OrderType } from "../../constant/orderType";
import { SEC_FONT_GREY } from "../../constant/colors";

import styled from "styled-components";

const { Text } = Typography;
const { Option } = Select;

const FormItemStyled = styled(Form.Item)`
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
    &::before {
      display: none;
    }
    &::after {
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      content: "*";
      color: ${SEC_FONT_GREY};
    }
  }
`;

const OrderTypeFormItemComponent = ({
  t,
  style,
  onSelect,
  defaultValue,
  required = false,
  editable = true,
  showLabel = false,
  strong = false,
  dataTMId,
  name = "isFreeDrug",
  recordInfo
}) => (
  <FormItemStyled
    name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
    label={
      showLabel ? (
        <Text strong={strong} style={{ color: "#9B9B9B" }}>
          {t("form.order_type.label")}
        </Text>
      ) : null
    }
    style={style}
    colon={false}
    rules={[{ required, message: t("form.order_type.error_required") }]}
  >
    {editable ? (
      <Select placeholder={t("form.order_type.placeholder")} style={style} onSelect={onSelect}>
        <Option value={true}>{OrderType.free.value(t)}</Option>
        <Option value={false}>{OrderType.replacement.value(t)}</Option>
      </Select>
    ) : (
      <Text data-tm-id={dataTMId}>{defaultValue ? `${defaultValue}` : "-"}</Text>
    )}
  </FormItemStyled>
);

const OrderTypeFormItem = withTranslation()(OrderTypeFormItemComponent);

export { OrderTypeFormItem };
